/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { BrandingUiInfoKeys } from '../../../core/entities/BrandingUiInfoKeys';
import { ServicesClientImpl } from '../../../core/interactors';
import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { TOverlayOptions } from '../../../core/types';
import { BrandingUiUtility } from '../../../core/utils';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController, showCloudDvrHelpScreen } from '../../screens/screens.reducers';

const SLO_OPTIONS = {
    CANCEL: 'CANCEL',
    LEARN_MORE: 'LEARN_MORE',
    OK: 'OK',
} as const;

const GLOBAL_MOUSE_TRAP = 'HideStorageLimitOverlay';

export const showStorageLimitOverlay = (callback: Function) => (dispatch: Function) => {
    const services = new ServicesClientImpl();
    const overlayProps: IOverlayDialog = {
        hasDimmer: true,
        hasSeperator: true,
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: [
            {
                text: Locale.getString(LocaleKeys.SLO_OPTION_OK),
                value: { action: SLO_OPTIONS.OK, callback },
            },
            {
                text: Locale.getString(LocaleKeys.SLO_OPTION_LEARN_MORE),
                value: { action: SLO_OPTIONS.LEARN_MORE },
            },
            {
                text: Locale.getString(LocaleKeys.SLO_OPTION_CANCEL),
                value: { action: SLO_OPTIONS.CANCEL },
            },
        ],
        description: BrandingUiUtility.formatDescription(Locale.getString(LocaleKeys.SLO_BODY), {
            CUSTOMER_SUPPORT_NAME: services.getBrandingUiInfoForKey(
                BrandingUiInfoKeys.CUSTOMER_SUPPORT_NAME,
            ),
            PHONE_CUSTOMER_SUPPORT_NUMBER: services.getBrandingUiInfoForKey(
                BrandingUiInfoKeys.PHONE_CUSTOMER_SUPPORT_NUMBER,
            ),
        }),
        title: Locale.getString(LocaleKeys.SLO_TITLE),
    };
    dispatch(hideOverlayDialog());
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.SLO_TASKS));
    dispatch(showOverlayDialog(overlayProps));
};

export const onKeyOkStorageLimitOverlay = () => (dispatch: Function, getState: Function) => {
    const { overlayHighlight, overlayDialog } = getState();
    const { verticalPosition } = overlayHighlight;
    const { uiProperties } = overlayDialog;
    const { options } = uiProperties;

    const selectedOption: TOverlayOptions = options[verticalPosition];

    switch (selectedOption.value.action) {
        case SLO_OPTIONS.CANCEL:
            dispatch(hideOverlayDialog());
            break;
        case SLO_OPTIONS.LEARN_MORE:
            dispatch(hideOverlayDialog());
            dispatch(showCloudDvrHelpScreen());

            break;
        case SLO_OPTIONS.OK:
            dispatch(selectedOption.value.callback());
            break;
        default:
    }
};

export const onMouseClickStorageLimitOverlay = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }

    dispatch(onKeyOkStorageLimitOverlay());
};
